/**
 * Handle the refinement flyouts.
 *
 * @author Erik Jan Lam
 * @date Mar 28 2019
 */

import 'sticky-sidebar';
import {debounce, throttle} from '../components/custom-lodash';
import {calculateBottomContentHeight} from './common';

let refinementsBar = null;

/**
 * Toggle class on document root element.
 * @param {event} event The click event on the toggle button.
 * @param {string | *} className The className to toggle, optional.
 */
function toggleClass(trigger, className) {
    const toggleClassName = trigger && trigger.dataset.toggle ? trigger.dataset.toggle : className;
    if (toggleClassName) {
        document.documentElement.classList.toggle(toggleClassName);
        document.documentElement.classList.toggle('filter-flyin-active');
        $('.refinement-temp').removeClass('refinement-temp selected');
        $('.selection-changed').removeClass('selection-changed');
        if (window.SitePreferences.HIDE_SEO_TEXT_ON_REFINEMENT) {
            $('.js-bottom-category-seo').removeClass('hidden');
        }
    }
}

function initStickySidebar() {
    if (!isStickyNecessary()) {
        destroyStickySidebar();
        return;
    }

    const el = document.getElementById('secondary');

    if (!el || window.innerWidth < 1024) {
        return;
    }

    const headerHeight = $('.xlt-header').height() || 0;

    if (window.stickySidebar) {
        destroyStickySidebar();
    }

    window.stickySidebar = new window.StickySidebar(el, {
        topSpacing: headerHeight,
        bottomSpacing: 20,
        containerSelector: '.grid.content-width-default'
    });
}

function destroyStickySidebar() {
    window.stickySidebar && window.stickySidebar.destroy && window.stickySidebar.destroy();
    if (window.stickySidebar) {
        delete window.stickySidebar;
    }
}

function updateStickySidebar() {
    if (!isStickyNecessary()) {
        destroyStickySidebar();
        return;
    }

    if (window.stickySidebar && window.stickySidebar.updateSticky) {
        window.stickySidebar.updateSticky();
    } else {
        initStickySidebar();
    }

    // Bottom transform is set when the last refinement element is overlapping with the bottom.
    const $main = $('main');
    const $bottom = $('#bottomcontent');

    const existingOffset = $main.attr('data-down-height');
    const originalHeight = $main.attr('data-original-height');

    if (existingOffset && existingOffset !== '0' && originalHeight) {
        $main.height(originalHeight);
        $main.attr('data-down-height', 0);
    }
    const lastRefinement = $('.refinements-list li.refinement:last-child');
    const lastRefinementEnd = lastRefinement.length ? lastRefinement.offset().top + lastRefinement.height() : 0;

    calculateBottomContentHeight($bottom, lastRefinementEnd);
}

function isStickyNecessary() {
    return $('#primary').height() > $('#secondary').height() + 100;
}

/**
 * @param {Event} e
 */
const handleToggle = e => {
    const toggleButton = e.target.closest('.js-refinements-toggle');
    const $colorContainer = $('.swatches.refinementColor');
    if (toggleButton) {
        e.preventDefault();
        toggleClass(toggleButton);
        $colorContainer.find('.color-bubble').removeClass('color-bubble--background-hidden');
    }
};

/**
 * @param {Event} e
 */
const handleSideFilters = e => {
    if (e.target.matches('.side-filters') && document.documentElement.classList.contains('filter-flyin-active')) {
        document.documentElement.classList.remove('filter-flyin-active', 'refinements-active', 'categories-active');
    }
};

const resizeHandler = () => {
    if (window.innerWidth >= 1024) {
        updateStickySidebar();
    } else {
        destroyStickySidebar();
    }
};

const refreshSidebar = () => {
    if ($('#primary').height() > $('#secondary').height()) {
        initStickySidebar();
    } else {
        destroyStickySidebar();
    }
};

function init() {
    // init flyin toggle buttons.
    document.body.addEventListener('click', handleToggle);

    document.body.addEventListener('click', handleSideFilters);

    // Initialize when everything is loaded
    window.addEventListener('load', updateStickySidebar);

    // Position the side bar on desktop.
    refinementsBar = document.getElementById('secondary');
    if (refinementsBar) {
        window.addEventListener('resize', debounce(resizeHandler, 100));

        window.addEventListener('scroll', throttle(updateStickySidebar, 100));

        document.body.addEventListener('productlistingupdated', debounce(refreshSidebar, 100));
        document.body.addEventListener('moreproductsloaded', debounce(refreshSidebar, 100));
    }
}

exports.init = init;
